import styled from 'styled-components'

import { Dialog } from '@root/shared/ui-kit'

import { PremiumDialogHeader } from './premium-dialog-header'

import type { DialogProps } from '@root/shared/ui-kit'

type Props = DialogProps & {
  title: React.ReactNode
  onClose?: () => void
  onBack?: () => void
}

export const PremiumDialog: React.FC<Props> = ({
  children,
  title,
  onClose,
  onBack,
  ...props
}) => {
  return (
    <Root {...props}>
      <PremiumDialogHeader title={title} onClose={onClose} onBack={onBack} />

      {children}
    </Root>
  )
}

const Root = styled(Dialog)`
  background: var(--background-1);

  width: 418px;

  display: grid;
`
